/**
 * Format a list of full names into a comma-separated string of first names,
 * with an ampersand between the last two names.
 *
 * The first name is derived by splitting the full display name on whitespace
 * and taking the first token. The backend currently only provides a single
 * `name` field (full display name), so this is the best we can do client-side.
 *
 * Examples (assuming first names are derivable from the input):
 *   []                         -> ''
 *   ['Amira Badran']           -> 'Amira'
 *   ['Amira', 'Anya Smith']    -> 'Amira & Anya'
 *   ['Amira', 'Anya', 'Blaze'] -> 'Amira, Anya & Blaze'
 *
 * The function formats any number of names, but callers are responsible for
 * suppressing the output when the count exceeds maxCount (per design).
 */
export const formatFirstNames = (fullNames: string[]): string => {
	const firstNames = fullNames.map((name) => name.trim().split(/\s+/)[0]).filter(Boolean);

	if (firstNames.length === 0) {
		return '';
	}
	if (firstNames.length === 1) {
		return firstNames[0];
	}
	if (firstNames.length === 2) {
		return `${firstNames[0]} & ${firstNames[1]}`;
	}
	// 3 names: "A, B & C"
	const head = firstNames.slice(0, -1).join(', ');
	const tail = firstNames[firstNames.length - 1];
	return `${head} & ${tail}`;
};
